import { useState } from "react"
import { Tab, Tabs } from "react-bootstrap"
import Departments from "./Departments"
import Users from "./Users"
import Blocks from "./Blocks"
import CalendarSettings from "./CalendarSettings"
import StoragePositions from "./StoragePositions"

const Settings = () => {
  const [key, setKey] = useState("departments")

  return (
    <Tabs id="settings-tabs" activeKey={key} onSelect={(k) => setKey(k)} className="tabs-primary mb-3">
      <Tab eventKey="departments" title={<span><i className="bi bi-building me-2"></i>Středisko</span>}>
        <Departments tabActive={key === "departments"} />
      </Tab>
      <Tab eventKey="users" title={<span><i className="bi bi-people me-2"></i>Uživatelé</span>}>
        <Users tabActive={key === "users"} />
      </Tab>
      <Tab eventKey="blocks" title={<span><i className="bi bi-calendar-x me-2"></i>Blokace</span>}>
        <Blocks tabActive={key === "blocks"} />
      </Tab>
      <Tab eventKey="calendar" title={<span><i className="bi bi-calendar3 me-2"></i>Kalendář</span>}>
        <CalendarSettings tabActive={key === "calendar"} />
      </Tab>
      <Tab eventKey="storage-positions" title={<span><i className="bi bi-box-seam me-2"></i>Úschovy</span>}>
        <StoragePositions tabActive={key === "storage-positions"} />
      </Tab>
    </Tabs>
  )
}

export default Settings
